import { lazy } from "react";
import {hasSidebarPermission} from "../utils/permissions";
const NotificationsSettings = lazy(() =>
  import("../views/notifications-settings")
);
const Modern = lazy(() => import("../views/dashboards/Modern"));
const Wallets = lazy(() => import("../views/wallets/Wallets"));
const Balances = lazy(() => import("../views/wallets/Balances"));
const Verifications = lazy(() => import("../views/wallets/Verifications"));
const PaymentProviders = lazy(() => import("../views/payment-providers/PaymentProviders"));
const WhitelistedAddresses = lazy(() => import("../views/whitelisted-addresses/WhitelistedAddresses"));
const SumSubAddresses = lazy(() => import("../views/sumsub-addresses/SumSubAddresses"));
const Sites = lazy(() => import("../views/sites/Sites"));
const Questionnaires = lazy(() => import("../views/questionnaires/Questionnaires"));
const Transaction = lazy(() => import("../views/transaction"));
const Company = lazy(() => import("../views/company"));
const ManualTransactions = lazy(() => import("../views/transactions/ManualTransactions"));
const NonManualTransactions = lazy(() => import("../views/transactions/NonManualTransactions"));
const SumSubTransactions = lazy(() => import("../views/sum-sub-transactions/SumSubTransactionsDataGrid"));
const TransactionsReview = lazy(() =>
  import("../views/transactions/TransactionsReview")
);
const Users = lazy(() => import("../views/users/UsersMUI"));
const Companies = lazy(() => import("../views/companies/Companies"));
const ChainStatus = lazy(() => import("../views/chain-status/ChainStatus"));
// const Company = lazy(() => import("../views/companies/Company"));
const KycPrograms = lazy(() => import("../views/kyc-programs/KycProgramsMUI"));
const KycDocuments = lazy(() => import("../views/kyc-documents/KycDocumentsMUI"));
const Roles = lazy(() => import("../views/roles/Roles"));
const Limitations = lazy(() => import("../views/limitations/Limitations"));
const AppliedLimitations = lazy(() =>
  import("../views/applied-limitations/AppliedLimitations")
);
const UserJournal = lazy(() => import("../views/user-journal/UserJournal"));
const FeeReports = lazy(() => import("../views/fee-reports/FeeReports"));
const Journal = lazy(() => import("../views/journal/Journal"));
const KycRequests = lazy(() => import("../views/kyc-requests/KycRequests"));
const System = lazy(() => import("../views/system/System"));
const Fees = lazy(() => import("../views/fees/Fees"));
const Profile = lazy(() => import("../views/profile/Profile"));
const QuestionnaireTabsController = lazy(() => import("../views/user-questionnaires/QuestionnaireTabsController"));

const ThemeRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    state: "dashboard",
    icon: "home",
    component: Modern,
    showInSideBar: true,
  },
  {
    path: "/wallet-management/wallets",
    name: "Customers",
    component: Wallets,
    showInSideBar: true,
    visible: (user) => hasSidebarPermission(user, 'customers'),
    icon: "codepen",
  },
  {
    path: "/wallet-management/questionnaire",
    name: "User Questionnaires",
    component: QuestionnaireTabsController,
    showInSideBar: false,
  },
  {
    path: "/transaction-management/transactions",
    name: "Transactions",
    state: "transactionmanagement",
    icon: "codepen",
    visible: (user) => {
      const manual = hasSidebarPermission(user, 'manual-trx');
      const nonManual = hasSidebarPermission(user, 'non-manual-trx');
      const dataExchange = hasSidebarPermission(user, 'data-exchange-trx');

      if (!manual && !nonManual && !dataExchange) return false;

      if (manual && !nonManual && !dataExchange) return true;

      return true;
    },
    component: (user) => {
      const manual = hasSidebarPermission(user, 'manual-trx');
      const nonManual = hasSidebarPermission(user, 'non-manual-trx');
      const dataExchange = hasSidebarPermission(user, 'data-exchange-trx');

      if (manual && !nonManual && !dataExchange) {
        return ManualTransactions;
      }

      return null;
    },
    collapse: true,
    showInSideBar: true,
    child: [
      {
        path: "/transaction-management/manual-transactions",
        name: "Manual Transactions",
        component: ManualTransactions,
        visible: (user) => hasSidebarPermission(user, 'manual-trx'),
      },
      {
        path: "/transaction-management/non-manual-transactions",
        name: "Non Manual Transactions",
        component: NonManualTransactions,
        visible: (user) => hasSidebarPermission(user, 'non-manual-trx'),
      },
      {
        path: "/transaction-management/sum-sub-transactions",
        name: "Data Exchange Transactions",
        component: SumSubTransactions,
        visible: (user) => hasSidebarPermission(user, 'data-exchange-trx'),
      },
    ],
  },

  {
    path: "/user-management/users",
    name: "Users",
    component: Users,
    showInSideBar: true,
    visible: (user) => hasSidebarPermission(user, 'users'),
    icon: "user",
  },
  {
    path: "/company-management/companies/:userLogin",
    name: "Company",
    component: Company,
    showInSideBar: false,
  },
  {
    path: "/profile",
    name: "Profile",
    icon: "mdi mdi-account-network",
    component: Profile,
    showInSideBar: false,
  },
  {
    path: "/transaction",
    name: "Show Transaction",
    icon: "mdi mdi-account-network",
    component: Transaction,
    showInSideBar: false,
  },
  {
    collapse: true,
    path: "/wallet-management",
    name: "Wallet Management",
    state: "walletmanagement",
    icon: "codepen",
    showInSideBar: false,
    child: [
      {
        path: "/wallet-management/wallets",
        name: "Customers",
        component: Wallets,
        visible: (user) => hasSidebarPermission(user, 'customers'),
        showInSideBar: true,
      },
      {
        path: "/wallet-management/balances",
        name: "Balances",
        component: Balances,
        showInSideBar: true,
      },
      {
        path: "/wallet-management/verifications",
        name: "Verifications",
        component: Verifications,
        showInSideBar: true,
      },
    ],
  },
  {
    collapse: true,
    path: "/transaction-management",
    name: "Transactions",
    state: "transactionmanagement",
    icon: "codepen",
    showInSideBar: false,
    child: [
      {
        path: "/transaction-management/transactions/:num",
        name: "Transaction",
        component: Transaction,
        showInSideBar: false,
      },
    ],
  },
  {
    collapse: true,
    path: "/user-management",
    name: "User Management",
    state: "usermanagement",
    icon: "user",
    showInSideBar: false,
    child: [
      {
        path: "/user-management/users",
        name: "Users",
        component: Users,
        showInSideBar: true,
        visible: (user) => hasSidebarPermission(user, 'users'),
      },
    ],
  },
  {
    collapse: true,
    path: "/documents",
    name: "Compliance",
    state: "kyc-management",
    icon: "feather",
    showInSideBar: false,
    visible: () => false,
    child: [
      {
        path: "/documents/new-arrived",
        name: "Documents For Approval",
        component: KycRequests,
      },
      {
        path: "/transaction-management/review",
        name: "Transactions For Approval",
        component: TransactionsReview,
      },
    ],
  },
  {
    path: "/company-management/companies",
    name: "Companies",
    component: Companies,
    showInSideBar: true,
    visible: (user) => !!parseInt(user?.showCompanyMenuItem),
    icon: "user",
  },
  {
    path: "/journal",
    name: "Journal",
    component: Journal,
    icon: "codepen",
    showInSideBar: true,
    visible: (user) => hasSidebarPermission(user, 'journal'),
  },
  {
    path: "/user-journal",
    name: "Customer Journal",
    component: UserJournal,
    icon: "codepen",
    showInSideBar: true,
    visible: (user) => hasSidebarPermission(user, 'customer-journal'),
  },
  {
    collapse: true,
    path: "/reports",
    name: "Reports",
    state: "reports",
    icon: "cpu",
    showInSideBar: false,
    visible: () => false,
    child: [
      {
        path: "/reports/fee-reports",
        name: "Fee Reports",
        component: FeeReports,
        showInSideBar: false,
        visible: () => false,
      },
    ],
  },
  {
    collapse: true,
    path: "/settings",
    name: "Settings",
    state: "settings",
    icon: "feather",
    showInSideBar: true,
    visible: (user) => {
      const children = [
        {
          path: "/settings/payment-providers",
          name: "Payment Providers",
          component: PaymentProviders,
          visible: (u) => hasSidebarPermission(u, 'payment-providers'),
        },
        {
          path: "/settings/kyc-programs",
          name: "Wallet Programs",
          component: KycPrograms,
          visible: (u) => hasSidebarPermission(u, 'wallet-programs'),
        },
        {
          path: "/settings/whitelisted-addresses",
          name: "Whitelisted Addresses",
          component: WhitelistedAddresses,
          visible: (u) => hasSidebarPermission(u, 'whitelisted-addresses'),
        },
        {
          path: "/settings/sumsub-addresses",
          name: "SumSub Addresses",
          component: SumSubAddresses,
          visible: (u) => hasSidebarPermission(u, 'sumsub-addresses'),
        },
        {
          path: "/settings/system",
          name: "System Defaults",
          component: System,
          visible: (u) => hasSidebarPermission(u, 'system-defaults'),
        },
        {
          path: "/settings/fees",
          name: "Fees",
          component: Fees,
          visible: (u) => hasSidebarPermission(u, 'fees'),
        },
        {
          path: "/documents/document-types",
          name: "Documents Types",
          component: KycDocuments,
          visible: (u) => hasSidebarPermission(u, 'doc-types'),
        },
        {
          path: "/acl/roles-permissions",
          name: "Roles / Permissions",
          component: Roles,
          visible: (u) => hasSidebarPermission(u, 'roles-permissions'),
        },
        {
          path: "/settings/notifications",
          name: "Notifications",
          component: NotificationsSettings,
          visible: (u) => hasSidebarPermission(u, 'notifications'),
        },
        {
          path: "/limitations/limitations-names",
          name: "Limitation Names",
          component: Limitations,
          visible: (u) => hasSidebarPermission(u, 'limitations'),
        },
        {
          path: "/limitations/applied-limitations",
          name: "Applied Limitations",
          component: AppliedLimitations,
          visible: (u) => hasSidebarPermission(u, 'applied-limitations'),
        },
      ];

      return children.some(child => child.visible(user));
    },
    child: [
      {
        path: "/settings/payment-providers",
        name: "Payment Providers",
        component: PaymentProviders,
        visible: (user) => hasSidebarPermission(user, 'payment-providers'),
      },
      {
        path: "/settings/kyc-programs",
        name: "Wallet Programs",
        component: KycPrograms,
        visible: (user) => hasSidebarPermission(user, 'wallet-programs'),
      },
      {
        path: "/settings/whitelisted-addresses",
        name: "Whitelisted Addresses",
        component: WhitelistedAddresses,
        visible: (user) => hasSidebarPermission(user, 'whitelisted-addresses'),
      },
      {
        path: "/settings/sumsub-addresses",
        name: "SumSub Addresses",
        component: SumSubAddresses,
        visible: (user) => hasSidebarPermission(user, 'sumsub-addresses'),
      },
      {
        path: "/settings/system",
        name: "System Defaults",
        component: System,
        visible: (user) => hasSidebarPermission(user, 'system-defaults'),
      },
      {
        path: "/settings/fees",
        name: "Fees",
        component: Fees,
        visible: (user) => hasSidebarPermission(user, 'fees'),
      },
      {
        path: "/documents/document-types",
        name: "Documents Types",
        component: KycDocuments,
        visible: (user) => hasSidebarPermission(user, 'doc-types'),
      },
      {
        path: "/acl/roles-permissions",
        name: "Roles / Permissions",
        component: Roles,
        visible: (user) => hasSidebarPermission(user, 'roles-permissions'),
      },
      {
        path: "/settings/notifications",
        name: "Notifications",
        component: NotificationsSettings,
        visible: (user) => hasSidebarPermission(user, 'notifications'),
      },
      {
        path: "/limitations/limitations-names",
        name: "Limitation Names",
        component: Limitations,
        visible: (user) => hasSidebarPermission(user, 'limitations'),
      },
      {
        path: "/limitations/applied-limitations",
        name: "Applied Limitations",
        component: AppliedLimitations,
        visible: (user) => hasSidebarPermission(user, 'applied-limitations'),
      },
    ],
  },
];
export default ThemeRoutes;
